import { format, isSameDay, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { isDateWithTime } from "./manageDate";

export function formatFrenchPhoneNumber(phone: string): string {
  // Supprimer tous les caractères non numériques sauf le "+"
  let cleaned = phone.replace(/[^\d+]/g, "");

  // Vérifier si le numéro commence par +33 (indicatif FR) et l'ajuster
  if (cleaned.startsWith("+33")) {
    cleaned = cleaned.replace("+33", "0"); // Remplace "+33" par "0"
  }

  // Vérifier si le numéro est valide (10 chiffres après correction)
  if (!/^0[1-9]\d{8}$/.test(cleaned)) {
    return "Numéro invalide";
  }

  // Ajouter des espaces pour le format standard "06 12 34 56 78"
  return cleaned.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
}

export const displayDateTime = (date: Date) => {
  const hasTime = isDateWithTime(date);

  return date.toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: hasTime ? '2-digit' : undefined,
    minute: hasTime ? '2-digit' : undefined,
  })
};

export function isMidnight(date: Date) {
  return format(date, "HH:mm") === '00:00';
}

export function formatDates(startDateTimeStr: string, endDateTimeStr: string | null, allDay?: boolean) {
  const startDateTime = parseISO(startDateTimeStr);
  // When the caller knows the all-day intent, trust it; otherwise fall back to
  // the midnight heuristic for callers without an all_day flag (e.g. meetings).
  const hideTime = allDay ?? (format(startDateTime, "HH:mm") === '00:00');

  if (!endDateTimeStr) {
    return hideTime
      ? format(startDateTime, "EEEE d MMMM yyyy", { locale: fr })
      : format(startDateTime, "EEEE d MMMM yyyy 'à' HH'h'mm", { locale: fr });
  }

  const endDateTime = parseISO(endDateTimeStr);
  const sameDay = isSameDay(startDateTime, endDateTime);

  if (sameDay && hideTime) {
    return format(startDateTime, "EEEE d MMMM yyyy", { locale: fr });
  }

  if (sameDay) {
    return `${format(startDateTime, "EEEE d MMMM yyyy 'de' HH'h'mm", { locale: fr })} à ${format(endDateTime, "HH'h'mm", { locale: fr })}`;
  }

  if (hideTime) {
    return `du ${format(startDateTime, "EEEE d MMMM", { locale: fr })} au ${format(endDateTime, "EEEE d MMMM yyyy", { locale: fr })}`;
  }

  return `du ${format(startDateTime, "EEEE d MMMM 'à' HH'h'mm yyyy", { locale: fr })} au ${format(endDateTime, "d MMMM 'à' HH'h'mm", { locale: fr })}`;
}
